import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b8955ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center comment" }
const _hoisted_2 = {
  key: 0,
  class: "invalid-error-comment"
}
const _hoisted_3 = {
  key: 1,
  class: "invalid-error-comment mar-bot-15"
}
const _hoisted_4 = {
  key: 2,
  class: "invalid-error-comment mar-bot-15"
}
const _hoisted_5 = {
  key: 3,
  class: "invalid-error-comment mar-bot-15"
}

import Avatar from '@/components/avatar/index.vue'
import { translate } from '@/languages/i18n'
import { computed, PropType, ref, ComputedRef, watch } from 'vue-demi'
import { useStore } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { ACCOUNT_STORE, COMMUNITY_SITE_ADMIN_STORE, COMMUNITY_SITE_STORE, COMMUNITY_STORE, POST_STORE } from '@/store/constants'
import { PostType } from '@/store/modules/post'
import { CommunityStateTypes } from '@/store/modules/community'
import { cloneDeep, debounce } from 'lodash'
import commonService from '@/services/common.service'
import { useRoute } from 'vue-router'
import { checkLimitMention, customMaxLengthTextMention, isSaasTypePool } from '@/utils'
import { userType } from '@/use/usePath'
import MentionTextarea from '@/components/mention-textarea/index.vue'
import { HANDLE_USERS_MENTION } from '@/constants/common'


export default /*#__PURE__*/_defineComponent({
  props: {
  post: {
    type: Object as PropType<PostType>,
  },
  create_by_admin: Boolean,
  reset: Boolean,
  admin: Boolean,
  isCSPDetail: Boolean,
  users: {
    type: Array,
    required: false,
  },
  isCSP: {
    type: Boolean,
    default: false,
  },
  titleMention: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props


const route = useRoute()

const formData = ref({
  comment: '',
  mention_user_ids: [],
  rawContent: '',
})

const mentionComponent = ref<{ clear: () => void } | null>(null)

const store = useStore()

const profile = computed<Pick<CommunityStateTypes, 'me'>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME]?.profile)
const profileCommunity = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.COMMUNITY_INFO])
const listUserShow = computed(() => store.getters[ACCOUNT_STORE.GETTERS.LIST_USER_WITH_DELETED])

const ngKeyComment = ref<boolean>(false)
const isCheckedNGKeyComment = { value: false }
const errorOccurred = ref(false)

const rules = computed(() => {
  return {
    comment: {
      maxLength: (value: string) => customMaxLengthTextMention(value, 500, formData.value.mention_user_ids, props.users, formData.value.rawContent),
      limitMention: (value: string) => checkLimitMention(value, formData.value.mention_user_ids),
    },
  }
})

const storeSaasType = computed(() => store.getters[COMMUNITY_STORE.GETTERS.GET_SAAS_TYPE])

const v$ = useVuelidate(rules, formData)

const createComment = async () => {
  v$.value.$touch()
  if (!formData.value.comment || v$.value.$invalid || ngKeyComment.value || errorOccurred.value) return

  isCheckedNGKeyComment.value = false
  await checkNGKeyComment()
  while (!isCheckedNGKeyComment.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (ngKeyComment.value) return
  if (props?.isCSPDetail) {
    store.dispatch(COMMUNITY_SITE_STORE.ACTIONS.SET_COMMENT_CSP, {
      comment: {
        comment: formData.value.comment,
        create_by_admin: cloneDeep(props.create_by_admin),
        mention_user_ids: formData.value.mention_user_ids,
      },
      post_id: props.post?.id,
    })
  } else {
    store.dispatch(POST_STORE.ACTIONS.SET_COMMENT, {
      comment: {
        comment: formData.value.comment,
        create_by_admin: cloneDeep(props.create_by_admin),
        mention_user_ids: formData.value.mention_user_ids,
        from_sf_10: props.isCSP,
      },
      post_id: props.post.id,
    })
  }
  v$.value.$reset()
  mentionComponent.value?.clear()
  Object.assign(formData.value, {
    comment: '',
    mention_user_ids: [],
  })
}

const changeContent = async (content: any) => {
  v$.value.comment.$model = content.content
  formData.value.mention_user_ids = content.mentionedUserIds
  formData.value.rawContent = content.rawContent
  await checkNGKeyComment()
}
const checkErrorOccurred = (error: boolean) => {
  errorOccurred.value = error
}
const getListUserMention = async () => {
  if (!props.post.published && props.create_by_admin) {
    await store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.GET_USER_MENTION_LIST, { id: props.post.id, create_by_admin: true })
  } else {
    if (props.create_by_admin) {
      if (storeSaasType.value && !isSaasTypePool(storeSaasType.value)) {
        await store.dispatch(POST_STORE.ACTIONS.GET_USER_MENTION_POST, { post_id: props.post.id, create_by_admin: true })
      }
    } else {
      await store.dispatch(POST_STORE.ACTIONS.GET_USER_MENTION_POST, { post_id: props.post.id })
    }
  }
}

watch(
  () => props.reset,
  () => {
    Object.assign(formData.value, {
      comment: '',
      mention_users: [],
    })
    mentionComponent.value?.clear()
    ngKeyComment.value = false
    errorOccurred.value = false
  },

  { deep: true }
)

const checkNGKeyComment = debounce(async () => {
  try {
    const data = await commonService.sendNGWordCheck({ sentence: formData.value.comment })
    ngKeyComment.value = data.data?.data?.has_ngword
    if (data.request.status == 403) ngKeyComment.value = true
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyComment.value = true
  }
}, 300)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(Avatar, {
          size: "small",
          user_image_url: __props.create_by_admin ? _unref(profileCommunity)?.profile_image_url || _unref(profileCommunity)?.image_url : _unref(profile)?.image_url,
          userType: __props.admin ? 'community_admin' : _unref(userType)()
        }, null, 8, ["user_image_url", "userType"])
      ]),
      _createVNode(MentionTextarea, {
        ref: (_value, _refs) => {
          _refs['mentionComponent'] = _value
          mentionComponent.value = _value
        },
        users: _unref(HANDLE_USERS_MENTION)(__props.users, _unref(listUserShow)),
        "title-mention": __props.titleMention ? __props.titleMention : _unref(translate)('titleMentionPost'),
        "class-name": ['form-control input-mb editable-input'],
        disabled: 
        ([1, 2].includes(__props.post?.is_deleted_in_30_days) && __props.post?.user_type !== 'community_admin' && !_unref(route).path.match(`/operational_posts`)) ||
        (!__props.post?.available && __props.post?.is_deleted_in_30_days === 0 && __props.post?.user_type !== 'community_admin' && !_unref(route).path.match(`/operational_posts`)) ||
        (__props.post?.content_type === 5 && __props.post.is_community_site_deleted)
      ,
        placeholder: _unref(translate)('writeComment'),
        onContent: changeContent,
        onGetListUserMention: getListUserMention,
        onEventEnter: createComment,
        onCheckErrorOccurred: checkErrorOccurred
      }, null, 8, ["users", "title-mention", "disabled", "placeholder"]),
      _createElementVNode("button", {
        class: _normalizeClass(["btn-comment-mb bg-white ms-1 fw-bold", { disabled: !formData.value.comment.trim() }]),
        onClick: createComment
      }, "送信", 2)
    ]),
    (ngKeyComment.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
      : _createCommentVNode("", true),
    (_unref(v$).comment.$errors[0]?.$validator === 'maxLength')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(translate)('errorComment')), 1))
      : (_unref(v$).comment.$errors[0]?.$validator === 'limitMention')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(translate)('VALIDATE_NUMBER_OF_MENTION')), 1))
        : (errorOccurred.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(translate)('ERROR_MENTION_USER_INVALID')), 1))
          : _createCommentVNode("", true)
  ], 64))
}
}

})